<table style="width: 100%;" *ngIf="totalItemCount > 0">
  <tr>
    <td style="width: 45%; text-align: left;">
      <table>
        <tr>
          <td *ngFor="let i of itemCountPerPageSettings">
            <div class="roundBackground" [ngClass]="{'selected': (itemCountPerPageSetting == i.id), 'clickable': (itemCountPerPageSetting != i.id)}" (click)="itemCountPerSettingClicked(i.id)">{{i.text}}</div>
          </td>
          <td *ngIf="navigateToTheTopOfThePageElementId != null" style="padding-left: 30px;">
            <a class="clickable" (click)="toTheTop()">{{languageService.LNG('Label.Button.Search')}}...</a>
          </td>
        </tr>
      </table>
    </td>
    <td style="width: 55%; text-align: left;">
      <table *ngIf="totalPageCount > 1">
        <tr>
          <td style="padding-right: 20px;">
            <div style="white-space: nowrap;">{{languageService.LNG('Label.Page')}} {{currentPage}} {{languageService.LNG('Label.Of').toLowerCase()}} {{totalPageCount}} ({{totalItemCount}} {{languageService.LNG('Label.Items').toLowerCase()}})</div>
          </td>
          <td>
            <i class="dx-icon-chevronleft clickable" [ngClass]="{'clickable': (currentPage != 1)}" (click)="setCurrentPagePrevious()"></i>
          </td>
          <td>
            <table>
              <tr>
                <td *ngFor="let p of pagerAllPages">
                  <div [ngClass]="{'roundBackground': (p != 0), 'selected': (currentPage == p), 'clickable': (currentPage != p && p != 0) }" (click)="setCurrentPage(p)">{{(p != 0 ? p.toString() : ' .... ')}}</div>
                </td>
              </tr>
            </table>
          </td>
          <td>
            <i class="dx-icon-chevronright" [ngClass]="{'clickable': (currentPage != totalPageCount)}" (click)="setCurrentPageNext()"></i>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
